// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3VBy0","item":"style_item__1Y4R8","number":"style_number__68R4A","label":"style_label__3Jk6I","img":"style_img__2p3LE","allbtn":"style_allbtn__3Hk65"};